import {backendSingularKind} from './record_keys'
import {canSuspendForMissingEntityIndex, suspendForMissingEntityIndex} from './missing_entity_index'

const recordsByIdCache = new WeakMap()
const recordsByFieldCache = new WeakMap()
const fieldNamesByTableName = new Map()

const getFieldNames = tableName => {
	let fieldNames = fieldNamesByTableName.get(tableName)
	if (fieldNames) return fieldNames
	const backendKind = backendSingularKind(tableName)
	fieldNames = [`${backendKind}_id`, `${backendKind}_ids`]
	fieldNamesByTableName.set(tableName, fieldNames)
	return fieldNames
}

const getFieldName = (item, tableName) => getFieldNames(tableName).find(f => Object.prototype.hasOwnProperty.call(item, f))

export const getMissingCachedJoinId = (record, modelInstance, joinDescriptor) => {
	const fieldName = getFieldName(record, joinDescriptor.key)
	if (!fieldName) return null
	const id = record[fieldName]
	return id && !modelInstance[joinDescriptor.associationKey] ? id : null
}

export const resolveJoinRecords = ({record, parentKey, joinDescriptor, allRecords}) => {
	const joinRecords = allRecords[joinDescriptor.key] || []
	const ownFieldName = getFieldName(record, joinDescriptor.key)
	if (ownFieldName) return findOwnJoinRecords(record, ownFieldName, joinRecords, joinDescriptor, allRecords)
	if (!joinRecords.length) return joinDescriptor.isMultiple ? [] : null

	const mergeFieldName = getFieldName(joinRecords[0], parentKey)
	if (!mergeFieldName) return null
	const joinedRecords = getRecordsByField(joinRecords, mergeFieldName).get(record.id) || []
	return joinDescriptor.isMultiple ? joinedRecords : joinedRecords[0]
}

const findOwnJoinRecords = (record, fieldName, joinRecords, joinDescriptor, allRecords) => {
	const recordsById = getRecordsById(joinRecords)
	if (!joinDescriptor.isMultiple) {
		const id = record[fieldName]
		const joinedRecord = recordsById.get(id)
		if (canSuspendForMissingEntityIndex(joinDescriptor.key) && id && !joinedRecord) {
			suspendForMissingEntityIndex(joinDescriptor.key, id, allRecords)
		}
		return joinedRecord
	}
	const ids = Array.isArray(record[fieldName]) ? record[fieldName] : []
	return ids.map(id => recordsById.get(id)).filter(Boolean)
}

const getRecordsById = records => {
	let recordsById = recordsByIdCache.get(records)
	if (!recordsById) {
		recordsById = new Map(records.map(record => [record.id, record]))
		recordsByIdCache.set(records, recordsById)
	}
	return recordsById
}

const getRecordsByField = (records, fieldName) => {
	let indexesByField = recordsByFieldCache.get(records)
	if (!indexesByField) {
		indexesByField = new Map()
		recordsByFieldCache.set(records, indexesByField)
	}
	if (!indexesByField.has(fieldName)) indexesByField.set(fieldName, buildRecordsByField(records, fieldName))
	return indexesByField.get(fieldName)
}

const buildRecordsByField = (records, fieldName) => {
	return records.reduce((index, record) => {
		const value = record[fieldName]
		const ids = Array.isArray(value) ? value : [value]
		ids.filter(Boolean).forEach(id => {
			const recordsForId = index.get(id) || []
			recordsForId.push(record)
			index.set(id, recordsForId)
		})
		return index
	}, new Map())
}
